import React from 'react';

import { DiscoveryPluginsPanel } from '@/sections/customerManagement/components/masterDashboard/DiscoveryPluginsPanel';

export const MasterDashboard: React.FC = () => {
  return (
    <div className="flex h-full flex-col gap-4">
      <p className="text-chariot-text-secondary text-sm">
        Platform-wide configuration and data source management
      </p>
      <div className="h-full overflow-y-auto pb-6">
        <DiscoveryPluginsPanel />
      </div>
    </div>
  );
};
